const personList = ['Alice', 'Bob', 'Taylor'];

export { personList };
